import React, { useEffect, useState } from 'react';
import { alertError, alertSuccess } from '../../utils/logger';
import { useHistory } from 'react-router-dom';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Cancel from '@material-ui/icons/Cancel';
import { changeEventsUrl } from '../../api/user'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { therapistIsVerified } from '../../utils/auth';
import { Col, Row } from 'react-bootstrap';
import { Button, TextField } from '@material-ui/core';
import { getLanguages } from '../../api/language';
import { getCredentials } from '../../api/auth';
import { authActions } from '../modules/Auth/_redux/authActions';
import { grantPermissionsCalendar } from '../../api/calendar';
import {
	isGoogleCalendarTokenExpiredError,
	promptReconnectGoogleCalendar,
} from '../../utils/googleCalendarAuth';

const CONTACT_EMAIL = 'tonitorres.life@gmail.com';

function StepStatus({ completed }) {
	if (completed) {
		return <CheckCircle style={{ color: '#28a745', fontSize: 24 }} />;
	}
	return <Cancel style={{ color: '#dc3545', fontSize: 24 }} />;
}

function StepTitle({ fontSize, title, completed }) {
	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
			<strong><p style={{ fontSize, margin: 0 }}>{title}</p></strong>
			<StepStatus completed={completed} />
		</div>
	);
}

export function DashboardPage() {
	const user = useSelector((store) => store.authentication?.user, shallowEqual)
	const [isVerified, setIsVerified] = useState(true);
	const [therapist, setTherapist] = useState(user);
    const history = useHistory()
	const dispatch = useDispatch()

	async function fetchUser() {
		try {
			const response = await getCredentials()
			if (response)
				dispatch(authActions.loginActionSuccess(response?.data))
				const languages = await getLanguages();
				if (languages?.data) {
					dispatch(authActions.getLanguagesSuccess(languages?.data));
				}
		} catch (error) {
			dispatch(authActions.logoutAction())
		}
	}

	useEffect(() => {
		fetchUser();
	}, []);

	useEffect(() => {
		if (user) {
			setTherapist(user);
		   	setIsVerified(therapistIsVerified(user));
			if (therapistIsVerified(user)) {
				history.replace('/clients');
			}
		}
	}, [user])

	function text(fontSize, textContent, bold) {
		if (bold) return (<strong> <p style={{fontSize}}>{textContent}</p> </strong>)
		return (<p style={{fontSize}}>{textContent}</p>)
	}

	const handleChange = (element) => (event) => {
		setTherapist({ ...therapist, [element]: event.target.value})
	}

	function handleRequestInvitation() {
		grantPermissionsCalendar(user?._id, therapist?.fullName, therapist?.surname, therapist?.email)
			.then(() => {
				alertSuccess({ message: "Invitación al calendario enviada correctamente." });
				fetchUser();
			})
			.catch((error) => {
				if (isGoogleCalendarTokenExpiredError(error)) {
					promptReconnectGoogleCalendar(history);
					return;
				}
				alertError({ error, message: "No se ha podido enviar la invitación al calendario." });
			});
	}

	const textS = 16, titleS = 24;
	const canRequestInvitation = user?.googleTokens && user?.eventsUrl && !user?.calendarId;

	if (!isVerified)
	return (<>
			<div className='col justify-content-center'>
				{text(titleS, `Bienvenido/a al equipo del Método M.E.S., ${therapist?.fullName}!`, true)}
				<br />
				{text(textS, `Gracias por formar parte de este camino de acompañamiento y sanación.`)}
				{text(textS, `Antes de empezar a utilizar la plataforma, necesitamos que completes unos sencillos pasos para poder coordinar las sesiones de forma clara y fluida.`)}
				<br />
				{text(textS, `Primeros pasos`, true)}
				<br />
				<StepTitle fontSize={textS} title="Inicia sesión con Google" completed={!!therapist?.googleTokens} />
				
				<div style={{ display: 'flex', alignItems: 'center', gap: 12, }}>
					{text(textS, `Accede a la plataforma utilizando tu cuenta de Google. Será la misma cuenta que utilizarás para gestionar tus citas.`)}
					{ !user?.googleTokens && (
						<Button
							onClick={() => {
								history.push("/calendar?refresh=true")
							}}
							variant="outlined"
							color="primary"
							style={{ marginTop: -5, height: 30, marginRight: 200}}
						>
							Inicia sesión con google
						</Button>
					)}
				</div>

				<br />
				<StepTitle fontSize={textS} title="Crea tu agenda de citas en Google Calendar" completed={!!user?.eventsUrl} />
				{text(textS, `Entra en Google Calendar con esa misma cuenta de Gmail y crea una agenda destinada a tus sesiones (página de reserva).`)}
				{text(textS, `Una vez creada, copia el enlace de esa agenda y pégalo en el apartado correspondiente dentro de la plataforma.`)}
				{text(textS, `Después, guarda los cambios para que quede actualizada.`)}
				<Row>
					<Col sm={10}>
						<TextField
							id={`eventsUrl`}
							label="Url citas"
							value={therapist?.eventsUrl}
							onChange={handleChange("eventsUrl")}
							InputLabelProps={{
								shrink: true
							}}
							margin="normal"
							variant="outlined"
							required
						/>
					</Col>
					<Col>
					<Button
						onClick={() => {
							changeEventsUrl(user?._id, therapist?.eventsUrl)
								.then((res) => {
									alertSuccess({ message: "La url ha sido cambiada con éxito."});
									if (res?.data?.calendarInvitationError) {
										alertError({
											message: `La URL se guardó correctamente, pero no se pudo enviar la invitación al calendario. Puedes usar el botón "Solicitar invitación" o contactar con nosotros en ${CONTACT_EMAIL}.`,
										});
									}
									fetchUser();
								})
								.catch((error) => {
									alertError({ error, message: "Error cambiando la url de citas."})
								})
						}}
						variant="outlined"
						color="primary"
						style={{ marginTop: 18, height: 50}}
					>
						Actualizar url
					</Button>
					</Col>
				</Row>
				<br />
				<StepTitle fontSize={textS} title="Acepta la invitación al calendario compartido" completed={!!therapist?.calendarId} />
				{text(textS, `Recibirás un correo de Google Calendar con una invitación al calendario compartido del Método M.E.S.`)}
				{text(textS, `Es importante que la aceptes para que las citas puedan coordinarse correctamente.`)}
				{text(textS, `Si no has recibido este correo, puedes contactar con nosotros desde ${CONTACT_EMAIL} y te lo volveremos a enviar.`)}
				{canRequestInvitation && (
					<Button
						onClick={handleRequestInvitation}
						variant="outlined"
						color="primary"
						style={{ marginTop: 8 }}
					>
						Solicitar invitación
					</Button>
				)}
			</div>
	</>)

	return null;
}
